import { render } from "./MainSidebar.vue?vue&type=template&id=84b32fba&scoped=true&ts=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"

import "./MainSidebar.vue?vue&type=style&index=0&id=84b32fba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b32fba"]])

export default __exports__